// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export * from './enrollmentAccumulatorModel';
export * from './enrollmentAlternateCardId';
export * from './enrollmentCardInfoModel';
export * from './enrollmentClientIdentifiersModel';
export * from './enrollmentCommTypeUpdateRequestModel';
export * from './enrollmentCreatePrescriberRequestModel';
export * from './enrollmentCreatePrescriberResultModel';
export * from './enrollmentCreatePrescriberResultModelResponse';
export * from './enrollmentCreateSiteRequestModel';
export * from './enrollmentCreateSiteResultModel';
export * from './enrollmentCreateSiteResultModelResponse';
export * from './enrollmentDemographicsModel';
export * from './enrollmentDocumentModel';
export * from './enrollmentGileadWithdrawalBaseRequestModel';
export * from './enrollmentGileadWithdrawalRequestModel';
export * from './enrollmentGileadWithdrawalResultModel';
export * from './enrollmentGileadWithdrawalResultModelResponse';
export * from './enrollmentGovtExclusionEligibilityRequestModel';
export * from './enrollmentGuardianInfoModel';
export * from './enrollmentHistoryModel';
export * from './enrollmentHybridClientIdentifiersModel';
export * from './enrollmentHybridPatientLookupResultModel';
export * from './enrollmentHybridPatientLookupResultModelResponse';
export * from './enrollmentHybridPatientSearchDemographicsModel';
export * from './enrollmentHybridPatientSearchResultModel';
export * from './enrollmentHybridPatientSearchResultModelResponse';
export * from './enrollmentInsVerRequestModel';
export * from './enrollmentInsuranceVerificationModel';
export * from './enrollmentMedBenClientIdentifiersModel';
export * from './enrollmentMedBenInsuranceVerificationModel';
export * from './enrollmentMedBenOptOutRequestModel';
export * from './enrollmentMedBenPatientSearchRequestModel';
export * from './enrollmentMedBenPatientSearchResultModel';
export * from './enrollmentMedBenPatientSearchResultModelResponse';
export * from './enrollmentMedicationModel';
export * from './enrollmentPatientLookupRequestModel';
export * from './enrollmentPatientLookupResultModel';
export * from './enrollmentPatientLookupResultModelResponse';
export * from './enrollmentPatientSearchRecordModel';
export * from './enrollmentPatientSearchRequestModel';
export * from './enrollmentPatientSearchResultModel';
export * from './enrollmentPatientSearchResultModelResponse';
export * from './enrollmentPatientUpdateDemographicsModel';
export * from './enrollmentPatientUpdateRequestModel';
export * from './enrollmentPhoneNumberModel';
export * from './enrollmentPostmanCollectionModel';
export * from './enrollmentPostmanDataModel';
export * from './enrollmentPostmanFolderModel';
export * from './enrollmentPostmanRequestModel';
export * from './enrollmentRequestModel';
export * from './enrollmentResendCorrespondenceRequestModel';
export * from './enrollmentResendCorrespondenceResultModel';
export * from './enrollmentResendCorrespondenceResultModelResponse';
export * from './enrollmentResponseModel';
export * from './enrollmentResultModel';
export * from './enrollmentResultModelResponse';
export * from './enrollmentServiceStatusModel';
export * from './enrollmentSimplePatientSearchRequestModel';
export * from './enrollmentSimplePatientSearchResultModel';
export * from './enrollmentSimplePatientSearchResultModelResponse';
export * from './enrollmentSurveyQuestionModel';
export * from './enrollmentUpdatePrescriberRequestModel';
export * from './enrollmentUpdateRequestModel';
export * from './enrollmentUpdateSiteRequestModel';
export * from './enrollmentVerifySurveyEntryRequestModel';
export * from './enrollmentVerifySurveyEntryResultModel';
export * from './enrollmentVerifySurveyEntryResultModelResponse';
export * from './enrollmentWithPdfResultModel';
export * from './enrollmentWithPdfResultModelResponse';
export * from './expressEnrollmentRequestModel';
export * from './expressEnrollmentResultModel';
export * from './expressEnrollmentResultModelResponse';
export * from './gileadEnrollmentBaseRequestModel';
export * from './gileadEnrollmentRequestModel';
export * from './gileadEnrollmentResultModel';
export * from './gileadEnrollmentResultModelResponse';
export * from './gileadEnrollmentUpdateBaseRequestModel';
export * from './gileadEnrollmentUpdateRequestModel';
export * from './gileadEnrollmentUpdateResultModel';
export * from './gileadEnrollmentUpdateResultModelResponse';
export * from './gileadReEnrollmentBaseRequestModel';
export * from './gileadReEnrollmentRequestModel';
export * from './hybridEnrollmentDemographicsModel';
export * from './hybridEnrollmentHistoryModel';
export * from './hybridEnrollmentRequestModel';
export * from './hybridEnrollmentResultModel';
export * from './hybridEnrollmentResultModelResponse';
export * from './hybridSiteEnrollmentModel';
export * from './medBenEnrollmentDemographicsModel';
export * from './medBenEnrollmentRequestModel';
export * from './medBenEnrollmentResultModel';
export * from './medBenEnrollmentResultModelResponse';
export * from './medBenEnrollmentUpdateRequestModel';
export * from './reenrollmentEligibilityRequestModel';
export * from './siteEnrollmentModel';
import { ObjectSerializer } from '@trialcard/shared';
import { 
// @ts-ignore
AlternateCardType, 
// @ts-ignore
TCSCommunicationType, 
// @ts-ignore
TCSSource, 
// @ts-ignore
TCSCommunicationOption, 
// @ts-ignore
TCSRelationshipType, 
// @ts-ignore
TCSPaymentType, 
// @ts-ignore
TCSInsuranceType, 
// @ts-ignore
TCSEligibilityStatus, 
// @ts-ignore
QueryStringMatch, 
// @ts-ignore
ContactInfoType, 
// @ts-ignore
TCSGileadCommOption, 
// @ts-ignore
TCSSiteType, } from '@trialcard/enums';
import { EnrollmentAccumulatorModel } from './enrollmentAccumulatorModel';
import { EnrollmentAlternateCardId } from './enrollmentAlternateCardId';
import { EnrollmentCardInfoModel } from './enrollmentCardInfoModel';
import { EnrollmentClientIdentifiersModel } from './enrollmentClientIdentifiersModel';
import { EnrollmentCommTypeUpdateRequestModel } from './enrollmentCommTypeUpdateRequestModel';
import { EnrollmentCreatePrescriberRequestModel } from './enrollmentCreatePrescriberRequestModel';
import { EnrollmentCreatePrescriberResultModel } from './enrollmentCreatePrescriberResultModel';
import { EnrollmentCreatePrescriberResultModelResponse } from './enrollmentCreatePrescriberResultModelResponse';
import { EnrollmentCreateSiteRequestModel } from './enrollmentCreateSiteRequestModel';
import { EnrollmentCreateSiteResultModel } from './enrollmentCreateSiteResultModel';
import { EnrollmentCreateSiteResultModelResponse } from './enrollmentCreateSiteResultModelResponse';
import { EnrollmentDemographicsModel } from './enrollmentDemographicsModel';
import { EnrollmentDocumentModel } from './enrollmentDocumentModel';
import { EnrollmentGileadWithdrawalBaseRequestModel } from './enrollmentGileadWithdrawalBaseRequestModel';
import { EnrollmentGileadWithdrawalRequestModel } from './enrollmentGileadWithdrawalRequestModel';
import { EnrollmentGileadWithdrawalResultModel } from './enrollmentGileadWithdrawalResultModel';
import { EnrollmentGileadWithdrawalResultModelResponse } from './enrollmentGileadWithdrawalResultModelResponse';
import { EnrollmentGovtExclusionEligibilityRequestModel } from './enrollmentGovtExclusionEligibilityRequestModel';
import { EnrollmentGuardianInfoModel } from './enrollmentGuardianInfoModel';
import { EnrollmentHistoryModel } from './enrollmentHistoryModel';
import { EnrollmentHybridClientIdentifiersModel } from './enrollmentHybridClientIdentifiersModel';
import { EnrollmentHybridPatientLookupResultModel } from './enrollmentHybridPatientLookupResultModel';
import { EnrollmentHybridPatientLookupResultModelResponse } from './enrollmentHybridPatientLookupResultModelResponse';
import { EnrollmentHybridPatientSearchDemographicsModel } from './enrollmentHybridPatientSearchDemographicsModel';
import { EnrollmentHybridPatientSearchResultModel } from './enrollmentHybridPatientSearchResultModel';
import { EnrollmentHybridPatientSearchResultModelResponse } from './enrollmentHybridPatientSearchResultModelResponse';
import { EnrollmentInsVerRequestModel } from './enrollmentInsVerRequestModel';
import { EnrollmentInsuranceVerificationModel } from './enrollmentInsuranceVerificationModel';
import { EnrollmentMedBenClientIdentifiersModel } from './enrollmentMedBenClientIdentifiersModel';
import { EnrollmentMedBenInsuranceVerificationModel } from './enrollmentMedBenInsuranceVerificationModel';
import { EnrollmentMedBenOptOutRequestModel } from './enrollmentMedBenOptOutRequestModel';
import { EnrollmentMedBenPatientSearchRequestModel } from './enrollmentMedBenPatientSearchRequestModel';
import { EnrollmentMedBenPatientSearchResultModel } from './enrollmentMedBenPatientSearchResultModel';
import { EnrollmentMedBenPatientSearchResultModelResponse } from './enrollmentMedBenPatientSearchResultModelResponse';
import { EnrollmentMedicationModel } from './enrollmentMedicationModel';
import { EnrollmentPatientLookupRequestModel } from './enrollmentPatientLookupRequestModel';
import { EnrollmentPatientLookupResultModel } from './enrollmentPatientLookupResultModel';
import { EnrollmentPatientLookupResultModelResponse } from './enrollmentPatientLookupResultModelResponse';
import { EnrollmentPatientSearchRecordModel } from './enrollmentPatientSearchRecordModel';
import { EnrollmentPatientSearchRequestModel } from './enrollmentPatientSearchRequestModel';
import { EnrollmentPatientSearchResultModel } from './enrollmentPatientSearchResultModel';
import { EnrollmentPatientSearchResultModelResponse } from './enrollmentPatientSearchResultModelResponse';
import { EnrollmentPatientUpdateDemographicsModel } from './enrollmentPatientUpdateDemographicsModel';
import { EnrollmentPatientUpdateRequestModel } from './enrollmentPatientUpdateRequestModel';
import { EnrollmentPhoneNumberModel } from './enrollmentPhoneNumberModel';
import { EnrollmentPostmanCollectionModel } from './enrollmentPostmanCollectionModel';
import { EnrollmentPostmanDataModel } from './enrollmentPostmanDataModel';
import { EnrollmentPostmanFolderModel } from './enrollmentPostmanFolderModel';
import { EnrollmentPostmanRequestModel } from './enrollmentPostmanRequestModel';
import { EnrollmentRequestModel } from './enrollmentRequestModel';
import { EnrollmentResendCorrespondenceRequestModel } from './enrollmentResendCorrespondenceRequestModel';
import { EnrollmentResendCorrespondenceResultModel } from './enrollmentResendCorrespondenceResultModel';
import { EnrollmentResendCorrespondenceResultModelResponse } from './enrollmentResendCorrespondenceResultModelResponse';
import { EnrollmentResponseModel } from './enrollmentResponseModel';
import { EnrollmentResultModel } from './enrollmentResultModel';
import { EnrollmentResultModelResponse } from './enrollmentResultModelResponse';
import { EnrollmentServiceStatusModel } from './enrollmentServiceStatusModel';
import { EnrollmentSimplePatientSearchRequestModel } from './enrollmentSimplePatientSearchRequestModel';
import { EnrollmentSimplePatientSearchResultModel } from './enrollmentSimplePatientSearchResultModel';
import { EnrollmentSimplePatientSearchResultModelResponse } from './enrollmentSimplePatientSearchResultModelResponse';
import { EnrollmentSurveyQuestionModel } from './enrollmentSurveyQuestionModel';
import { EnrollmentUpdatePrescriberRequestModel } from './enrollmentUpdatePrescriberRequestModel';
import { EnrollmentUpdateRequestModel } from './enrollmentUpdateRequestModel';
import { EnrollmentUpdateSiteRequestModel } from './enrollmentUpdateSiteRequestModel';
import { EnrollmentVerifySurveyEntryRequestModel } from './enrollmentVerifySurveyEntryRequestModel';
import { EnrollmentVerifySurveyEntryResultModel } from './enrollmentVerifySurveyEntryResultModel';
import { EnrollmentVerifySurveyEntryResultModelResponse } from './enrollmentVerifySurveyEntryResultModelResponse';
import { EnrollmentWithPdfResultModel } from './enrollmentWithPdfResultModel';
import { EnrollmentWithPdfResultModelResponse } from './enrollmentWithPdfResultModelResponse';
import { ExpressEnrollmentRequestModel } from './expressEnrollmentRequestModel';
import { ExpressEnrollmentResultModel } from './expressEnrollmentResultModel';
import { ExpressEnrollmentResultModelResponse } from './expressEnrollmentResultModelResponse';
import { GileadEnrollmentBaseRequestModel } from './gileadEnrollmentBaseRequestModel';
import { GileadEnrollmentRequestModel } from './gileadEnrollmentRequestModel';
import { GileadEnrollmentResultModel } from './gileadEnrollmentResultModel';
import { GileadEnrollmentResultModelResponse } from './gileadEnrollmentResultModelResponse';
import { GileadEnrollmentUpdateBaseRequestModel } from './gileadEnrollmentUpdateBaseRequestModel';
import { GileadEnrollmentUpdateRequestModel } from './gileadEnrollmentUpdateRequestModel';
import { GileadEnrollmentUpdateResultModel } from './gileadEnrollmentUpdateResultModel';
import { GileadEnrollmentUpdateResultModelResponse } from './gileadEnrollmentUpdateResultModelResponse';
import { GileadReEnrollmentBaseRequestModel } from './gileadReEnrollmentBaseRequestModel';
import { GileadReEnrollmentRequestModel } from './gileadReEnrollmentRequestModel';
import { HybridEnrollmentDemographicsModel } from './hybridEnrollmentDemographicsModel';
import { HybridEnrollmentHistoryModel } from './hybridEnrollmentHistoryModel';
import { HybridEnrollmentRequestModel } from './hybridEnrollmentRequestModel';
import { HybridEnrollmentResultModel } from './hybridEnrollmentResultModel';
import { HybridEnrollmentResultModelResponse } from './hybridEnrollmentResultModelResponse';
import { HybridSiteEnrollmentModel } from './hybridSiteEnrollmentModel';
import { MedBenEnrollmentDemographicsModel } from './medBenEnrollmentDemographicsModel';
import { MedBenEnrollmentRequestModel } from './medBenEnrollmentRequestModel';
import { MedBenEnrollmentResultModel } from './medBenEnrollmentResultModel';
import { MedBenEnrollmentResultModelResponse } from './medBenEnrollmentResultModelResponse';
import { MedBenEnrollmentUpdateRequestModel } from './medBenEnrollmentUpdateRequestModel';
import { ReenrollmentEligibilityRequestModel } from './reenrollmentEligibilityRequestModel';
import { SiteEnrollmentModel } from './siteEnrollmentModel';
export const Serializer = new ObjectSerializer({
    // @ts-ignore
    'AlternateCardType': AlternateCardType,
    // @ts-ignore
    'TCSCommunicationType': TCSCommunicationType,
    // @ts-ignore
    'TCSSource': TCSSource,
    // @ts-ignore
    "EnrollmentCreateSiteRequestModel.CommunicationTypesEnum": EnrollmentCreateSiteRequestModel.CommunicationTypesEnum,
    // @ts-ignore
    'TCSCommunicationOption': TCSCommunicationOption,
    // @ts-ignore
    'TCSSource': TCSSource,
    // @ts-ignore
    'TCSCommunicationType': TCSCommunicationType,
    // @ts-ignore
    'TCSRelationshipType': TCSRelationshipType,
    // @ts-ignore
    'TCSSource': TCSSource,
    // @ts-ignore
    "EnrollmentHybridPatientSearchDemographicsModel.CommunicationTypesEnum": EnrollmentHybridPatientSearchDemographicsModel.CommunicationTypesEnum,
    // @ts-ignore
    'TCSCommunicationOption': TCSCommunicationOption,
    // @ts-ignore
    'TCSPaymentType': TCSPaymentType,
    // @ts-ignore
    'TCSInsuranceType': TCSInsuranceType,
    // @ts-ignore
    'TCSSource': TCSSource,
    // @ts-ignore
    'TCSInsuranceType': TCSInsuranceType,
    // @ts-ignore
    'TCSEligibilityStatus': TCSEligibilityStatus,
    // @ts-ignore
    'TCSCommunicationType': TCSCommunicationType,
    // @ts-ignore
    'QueryStringMatch': QueryStringMatch,
    // @ts-ignore
    'QueryStringMatch': QueryStringMatch,
    // @ts-ignore
    "EnrollmentPatientUpdateDemographicsModel.CommunicationTypesEnum": EnrollmentPatientUpdateDemographicsModel.CommunicationTypesEnum,
    // @ts-ignore
    'TCSCommunicationOption': TCSCommunicationOption,
    // @ts-ignore
    'ContactInfoType': ContactInfoType,
    // @ts-ignore
    'TCSSource': TCSSource,
    // @ts-ignore
    "EnrollmentUpdateSiteRequestModel.CommunicationTypesEnum": EnrollmentUpdateSiteRequestModel.CommunicationTypesEnum,
    // @ts-ignore
    'TCSCommunicationOption': TCSCommunicationOption,
    // @ts-ignore
    'TCSSource': TCSSource,
    // @ts-ignore
    'TCSGileadCommOption': TCSGileadCommOption,
    // @ts-ignore
    'TCSGileadCommOption': TCSGileadCommOption,
    // @ts-ignore
    "HybridEnrollmentDemographicsModel.CommunicationTypesEnum": HybridEnrollmentDemographicsModel.CommunicationTypesEnum,
    // @ts-ignore
    'TCSCommunicationOption': TCSCommunicationOption,
    // @ts-ignore
    'TCSPaymentType': TCSPaymentType,
    // @ts-ignore
    'TCSSiteType': TCSSiteType,
    // @ts-ignore
    "HybridSiteEnrollmentModel.SiteCommunicationTypesEnum": HybridSiteEnrollmentModel.SiteCommunicationTypesEnum,
    // @ts-ignore
    'TCSCommunicationOption': TCSCommunicationOption,
    // @ts-ignore
    "HybridSiteEnrollmentModel.PrescriberCommunicationTypesEnum": HybridSiteEnrollmentModel.PrescriberCommunicationTypesEnum,
    // @ts-ignore
    'TCSCommunicationOption': TCSCommunicationOption,
    // @ts-ignore
    "MedBenEnrollmentDemographicsModel.CommunicationTypesEnum": MedBenEnrollmentDemographicsModel.CommunicationTypesEnum,
    // @ts-ignore
    'TCSCommunicationOption': TCSCommunicationOption,
    // @ts-ignore
    'TCSPaymentType': TCSPaymentType,
    // @ts-ignore
    'TCSSiteType': TCSSiteType,
    // @ts-ignore
    "SiteEnrollmentModel.SiteCommunicationTypesEnum": SiteEnrollmentModel.SiteCommunicationTypesEnum,
    // @ts-ignore
    'TCSCommunicationOption': TCSCommunicationOption,
    // @ts-ignore
    "SiteEnrollmentModel.PrescriberCommunicationTypesEnum": SiteEnrollmentModel.PrescriberCommunicationTypesEnum,
    // @ts-ignore
    'TCSCommunicationOption': TCSCommunicationOption,
}, {
    "EnrollmentAccumulatorModel": EnrollmentAccumulatorModel,
    "EnrollmentAlternateCardId": EnrollmentAlternateCardId,
    "EnrollmentCardInfoModel": EnrollmentCardInfoModel,
    "EnrollmentClientIdentifiersModel": EnrollmentClientIdentifiersModel,
    "EnrollmentCommTypeUpdateRequestModel": EnrollmentCommTypeUpdateRequestModel,
    "EnrollmentCreatePrescriberRequestModel": EnrollmentCreatePrescriberRequestModel,
    "EnrollmentCreatePrescriberResultModel": EnrollmentCreatePrescriberResultModel,
    "EnrollmentCreatePrescriberResultModelResponse": EnrollmentCreatePrescriberResultModelResponse,
    "EnrollmentCreateSiteRequestModel": EnrollmentCreateSiteRequestModel,
    "EnrollmentCreateSiteResultModel": EnrollmentCreateSiteResultModel,
    "EnrollmentCreateSiteResultModelResponse": EnrollmentCreateSiteResultModelResponse,
    "EnrollmentDemographicsModel": EnrollmentDemographicsModel,
    "EnrollmentDocumentModel": EnrollmentDocumentModel,
    "EnrollmentGileadWithdrawalBaseRequestModel": EnrollmentGileadWithdrawalBaseRequestModel,
    "EnrollmentGileadWithdrawalRequestModel": EnrollmentGileadWithdrawalRequestModel,
    "EnrollmentGileadWithdrawalResultModel": EnrollmentGileadWithdrawalResultModel,
    "EnrollmentGileadWithdrawalResultModelResponse": EnrollmentGileadWithdrawalResultModelResponse,
    "EnrollmentGovtExclusionEligibilityRequestModel": EnrollmentGovtExclusionEligibilityRequestModel,
    "EnrollmentGuardianInfoModel": EnrollmentGuardianInfoModel,
    "EnrollmentHistoryModel": EnrollmentHistoryModel,
    "EnrollmentHybridClientIdentifiersModel": EnrollmentHybridClientIdentifiersModel,
    "EnrollmentHybridPatientLookupResultModel": EnrollmentHybridPatientLookupResultModel,
    "EnrollmentHybridPatientLookupResultModelResponse": EnrollmentHybridPatientLookupResultModelResponse,
    "EnrollmentHybridPatientSearchDemographicsModel": EnrollmentHybridPatientSearchDemographicsModel,
    "EnrollmentHybridPatientSearchResultModel": EnrollmentHybridPatientSearchResultModel,
    "EnrollmentHybridPatientSearchResultModelResponse": EnrollmentHybridPatientSearchResultModelResponse,
    "EnrollmentInsVerRequestModel": EnrollmentInsVerRequestModel,
    "EnrollmentInsuranceVerificationModel": EnrollmentInsuranceVerificationModel,
    "EnrollmentMedBenClientIdentifiersModel": EnrollmentMedBenClientIdentifiersModel,
    "EnrollmentMedBenInsuranceVerificationModel": EnrollmentMedBenInsuranceVerificationModel,
    "EnrollmentMedBenOptOutRequestModel": EnrollmentMedBenOptOutRequestModel,
    "EnrollmentMedBenPatientSearchRequestModel": EnrollmentMedBenPatientSearchRequestModel,
    "EnrollmentMedBenPatientSearchResultModel": EnrollmentMedBenPatientSearchResultModel,
    "EnrollmentMedBenPatientSearchResultModelResponse": EnrollmentMedBenPatientSearchResultModelResponse,
    "EnrollmentMedicationModel": EnrollmentMedicationModel,
    "EnrollmentPatientLookupRequestModel": EnrollmentPatientLookupRequestModel,
    "EnrollmentPatientLookupResultModel": EnrollmentPatientLookupResultModel,
    "EnrollmentPatientLookupResultModelResponse": EnrollmentPatientLookupResultModelResponse,
    "EnrollmentPatientSearchRecordModel": EnrollmentPatientSearchRecordModel,
    "EnrollmentPatientSearchRequestModel": EnrollmentPatientSearchRequestModel,
    "EnrollmentPatientSearchResultModel": EnrollmentPatientSearchResultModel,
    "EnrollmentPatientSearchResultModelResponse": EnrollmentPatientSearchResultModelResponse,
    "EnrollmentPatientUpdateDemographicsModel": EnrollmentPatientUpdateDemographicsModel,
    "EnrollmentPatientUpdateRequestModel": EnrollmentPatientUpdateRequestModel,
    "EnrollmentPhoneNumberModel": EnrollmentPhoneNumberModel,
    "EnrollmentPostmanCollectionModel": EnrollmentPostmanCollectionModel,
    "EnrollmentPostmanDataModel": EnrollmentPostmanDataModel,
    "EnrollmentPostmanFolderModel": EnrollmentPostmanFolderModel,
    "EnrollmentPostmanRequestModel": EnrollmentPostmanRequestModel,
    "EnrollmentRequestModel": EnrollmentRequestModel,
    "EnrollmentResendCorrespondenceRequestModel": EnrollmentResendCorrespondenceRequestModel,
    "EnrollmentResendCorrespondenceResultModel": EnrollmentResendCorrespondenceResultModel,
    "EnrollmentResendCorrespondenceResultModelResponse": EnrollmentResendCorrespondenceResultModelResponse,
    "EnrollmentResponseModel": EnrollmentResponseModel,
    "EnrollmentResultModel": EnrollmentResultModel,
    "EnrollmentResultModelResponse": EnrollmentResultModelResponse,
    "EnrollmentServiceStatusModel": EnrollmentServiceStatusModel,
    "EnrollmentSimplePatientSearchRequestModel": EnrollmentSimplePatientSearchRequestModel,
    "EnrollmentSimplePatientSearchResultModel": EnrollmentSimplePatientSearchResultModel,
    "EnrollmentSimplePatientSearchResultModelResponse": EnrollmentSimplePatientSearchResultModelResponse,
    "EnrollmentSurveyQuestionModel": EnrollmentSurveyQuestionModel,
    "EnrollmentUpdatePrescriberRequestModel": EnrollmentUpdatePrescriberRequestModel,
    "EnrollmentUpdateRequestModel": EnrollmentUpdateRequestModel,
    "EnrollmentUpdateSiteRequestModel": EnrollmentUpdateSiteRequestModel,
    "EnrollmentVerifySurveyEntryRequestModel": EnrollmentVerifySurveyEntryRequestModel,
    "EnrollmentVerifySurveyEntryResultModel": EnrollmentVerifySurveyEntryResultModel,
    "EnrollmentVerifySurveyEntryResultModelResponse": EnrollmentVerifySurveyEntryResultModelResponse,
    "EnrollmentWithPdfResultModel": EnrollmentWithPdfResultModel,
    "EnrollmentWithPdfResultModelResponse": EnrollmentWithPdfResultModelResponse,
    "ExpressEnrollmentRequestModel": ExpressEnrollmentRequestModel,
    "ExpressEnrollmentResultModel": ExpressEnrollmentResultModel,
    "ExpressEnrollmentResultModelResponse": ExpressEnrollmentResultModelResponse,
    "GileadEnrollmentBaseRequestModel": GileadEnrollmentBaseRequestModel,
    "GileadEnrollmentRequestModel": GileadEnrollmentRequestModel,
    "GileadEnrollmentResultModel": GileadEnrollmentResultModel,
    "GileadEnrollmentResultModelResponse": GileadEnrollmentResultModelResponse,
    "GileadEnrollmentUpdateBaseRequestModel": GileadEnrollmentUpdateBaseRequestModel,
    "GileadEnrollmentUpdateRequestModel": GileadEnrollmentUpdateRequestModel,
    "GileadEnrollmentUpdateResultModel": GileadEnrollmentUpdateResultModel,
    "GileadEnrollmentUpdateResultModelResponse": GileadEnrollmentUpdateResultModelResponse,
    "GileadReEnrollmentBaseRequestModel": GileadReEnrollmentBaseRequestModel,
    "GileadReEnrollmentRequestModel": GileadReEnrollmentRequestModel,
    "HybridEnrollmentDemographicsModel": HybridEnrollmentDemographicsModel,
    "HybridEnrollmentHistoryModel": HybridEnrollmentHistoryModel,
    "HybridEnrollmentRequestModel": HybridEnrollmentRequestModel,
    "HybridEnrollmentResultModel": HybridEnrollmentResultModel,
    "HybridEnrollmentResultModelResponse": HybridEnrollmentResultModelResponse,
    "HybridSiteEnrollmentModel": HybridSiteEnrollmentModel,
    "MedBenEnrollmentDemographicsModel": MedBenEnrollmentDemographicsModel,
    "MedBenEnrollmentRequestModel": MedBenEnrollmentRequestModel,
    "MedBenEnrollmentResultModel": MedBenEnrollmentResultModel,
    "MedBenEnrollmentResultModelResponse": MedBenEnrollmentResultModelResponse,
    "MedBenEnrollmentUpdateRequestModel": MedBenEnrollmentUpdateRequestModel,
    "ReenrollmentEligibilityRequestModel": ReenrollmentEligibilityRequestModel,
    "SiteEnrollmentModel": SiteEnrollmentModel,
});
//# sourceMappingURL=models.js.map